var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticationReason, AuthenticationResult, AuthenticationStatus, ThreeDsStatus } from '@mc-alberta/types';
import { Adapter } from '../Adapter';
import { AuthenticationStrategy } from '../../types/enums/AuthenticationStrategy';
import getThreeDsBrowserData from '../../methods/getThreeDsBrowserData';
import { KpiOperation } from '../../types/enums/KpiOperation';
/**
 * Low-value, low-risk authentication.
 *
 * This is a frictionless strategy.
 * If a challenge is required, LVLR won't apply.
 */
export class LvlrAdapter extends Adapter {
    constructor() {
        super(...arguments);
        this.strategy = AuthenticationStrategy.LVLR;
        this.supportedReasons = [AuthenticationReason.TRANSACTION_AUTHENTICATION];
        /**
         * Attempts to authenticate using the low-value, low-risk strategy.
         */
        this.initializeSession = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.isChallengeRequired) {
                return this.destroySession();
            }
            this.kpi.start(KpiOperation.INITIATE_AUTHENTICATION);
            const session = yield this.refreshSession({
                threeDsData: {
                    threeDsInputData: Object.assign(Object.assign({}, (_a = this.authenticationContext.dpaTransactionOptions) === null || _a === void 0 ? void 0 : _a.threeDsInputData), { browser: Object.assign(Object.assign({}, getThreeDsBrowserData()), { threeDSCompInd: ThreeDsStatus.Failure }) })
                }
            });
            if (session.authenticationResult === AuthenticationResult.NOT_AUTHENTICATED) {
                this.authenticationStatus = AuthenticationStatus.NOT_SUPPORTED;
            }
            return this.getSession();
        });
    }
}
//# sourceMappingURL=index.js.map